import { createSelector } from 'reselect';

const selectContractsState = (state) => state.contracts.compensations;

export const selectCompensationsData = createSelector(selectContractsState, (state) => state.data);
